import DownloadLoader from '@shared/components/download-loader';
import { OperationReportTypeEnum } from '@shared/api/types';
import { cn } from '@shared/lib/utils';
import { QueryStatus } from '@tanstack/react-query';
import { cloneElement } from 'react';
import { ReportSection } from '../types';
import ReportLayoutTitle from './report-layout-title';

interface ReportDownloadContainerProps {
  status: QueryStatus;
  contentRef?: React.RefObject<HTMLElement>;
  Intro: React.FC;
  sections: ReportSection[];
  reportType?: OperationReportTypeEnum;
  downloadStatus?: 'idle' | 'generating' | 'generated';
}

export default function ReportDownloadContainer({
  status,
  contentRef,
  Intro,
  sections,
  reportType,
  downloadStatus,
}: ReportDownloadContainerProps) {
  const reportLabels = {
    idle: 'Preparing report...',
    generating: 'Generating PDF report...',
    generated: 'PDF report generated. You can now close this tab.',
  };

  if (status === 'loading') {
    return <DownloadLoader labels={reportLabels} />;
  }

  return (
    <div className="relative">
      <DownloadLoader downloadStatus={downloadStatus} labels={reportLabels} />
      <main
        className={`
          w-[--page-width]
          [--content-title-height:calc(var(--page-height)-var(--title-height))]
          [--page-height:21cm] [--page-width:29.7cm] [--title-height:3cm]
        `}
        ref={contentRef}
      >
        <Intro />
        {sections.map((item) => {
          if (item.show) {
            return (
              <div
                key={item.title}
                className={cn(
                  `w-full h-[--page-height] flex flex-col text-md font-light`
                )}
              >
                <ReportLayoutTitle
                  title={item.title}
                  preTitle={item.preTitle}
                  link={item.link}
                  downloadMode
                />
                {item.component &&
                  cloneElement(item.component, {
                    downloadMode: true,
                    reportType,
                  })}
              </div>
            );
          }
        })}
      </main>
    </div>
  );
}
